import React, { useEffect, PureComponent } from "react";
import { PieChart, Pie, Sector, ResponsiveContainer } from "recharts";
import StatsService from "../../apiservices/StatsService";
import { Loader } from "@fluentui/react-northstar";

const renderActiveShape = (props) => {
  const RADIAN = Math.PI / 180;
  const {
    cx,
    cy,
    midAngle,
    innerRadius,
    outerRadius,
    startAngle,
    endAngle,
    fill,
    payload,
    percent,
    value,
  } = props;
  const sin = Math.sin(-RADIAN * midAngle);
  const cos = Math.cos(-RADIAN * midAngle);
  const sx = cx + (outerRadius + 10) * cos;
  const sy = cy + (outerRadius + 10) * sin;
  const mx = cx + (outerRadius + 30) * cos;
  const my = cy + (outerRadius + 30) * sin;
  const ex = mx + (cos >= 0 ? 1 : -1) * 22;
  const ey = my;
  const textAnchor = cos >= 0 ? "start" : "end";

  return (
    <g>
      <text x={cx} y={cy} dy={8} textAnchor="middle" fill={fill}>
        {payload.name}
      </text>
      <Sector
        cx={cx}
        cy={cy}
        innerRadius={innerRadius}
        outerRadius={outerRadius}
        startAngle={startAngle}
        endAngle={endAngle}
        fill={fill}
      />
      <Sector
        cx={cx}
        cy={cy}
        startAngle={startAngle}
        endAngle={endAngle}
        innerRadius={outerRadius + 6}
        outerRadius={outerRadius + 10}
        fill={fill}
      />
      <path
        d={`M${sx},${sy}L${mx},${my}L${ex},${ey}`}
        stroke={fill}
        fill="none"
      />
      <circle cx={ex} cy={ey} r={2} fill={fill} stroke="none" />
      <text
        x={ex + (cos >= 0 ? 1 : -1) * 12}
        y={ey}
        textAnchor={textAnchor}
        fill="#333"
      >{`Atendidas ${value}`}</text>
      <text
        x={ex + (cos >= 0 ? 1 : -1) * 12}
        y={ey}
        dy={18}
        textAnchor={textAnchor}
        fill="#999"
      >
        {`(Rate ${(percent * 100).toFixed(2)}%)`}
      </text>
    </g>
  );
};

export default class AttendedByQueue extends PureComponent {
  state = {
    activeIndex: 0,
    data: [],
    isLoading: true,
  };

  componentDidMount() {
    const username = sessionStorage.getItem("userName");
    const tokenString = sessionStorage.getItem("tokenStats");
    const company = sessionStorage.getItem("company");
    for (let queue of this.props.queue) {
      StatsService.getDistributionByQueue(
        this.props.initDate,
        this.props.endDate,
        queue,
        tokenString,
        username,
        company
      ).then((res) => {
        this.setState((prevState) => ({
          data: [...prevState.data, res.data[0]],
        }));
        this.setState({
          isLoading: false,
        });
      });
    }
  }
  onPieEnter = (_, index) => {
    this.setState({
      activeIndex: index,
    });
  };

  render() {
    return (
      <>
        {this.state.isLoading ? (
          <Loader
            styles={{
              marginTop: "20%",
            }}
          />
        ) : (
          <ResponsiveContainer>
            <PieChart>
              <Pie
                activeIndex={this.state.activeIndex}
                activeShape={renderActiveShape}
                data={this.state.data}
                cx="50%"
                cy="50%"
                innerRadius={60}
                outerRadius={80}
                fill="#8884d8"
                dataKey="Atendidas"
                onMouseEnter={this.onPieEnter}
              />
            </PieChart>
          </ResponsiveContainer>
        )}
      </>
    );
  }
}
